import { observer } from 'mobx-react';
import { FC, Fragment, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';

import { LoadStatus } from '../../common/enums/load-status';
import { AcquisitionSegmentsStore } from '../stores/acquisition-segments.store';

export const AcquisitionSegmentsPage: FC = provide({
    singletons: [AcquisitionSegmentsStore],
})(
    observer(() => {
        const [{ initialize, readyState, data, source, basename }] =
            useDependencies(AcquisitionSegmentsStore);

        const params = useParams<{ id: string }>();

        useEffect(() => {
            initialize();
        }, [initialize]);

        return (
            <Fragment>
                {readyState === LoadStatus.Loading && <CenteredSpinner />}
                {readyState === LoadStatus.Ok && (
                    <Loader
                        className="w-100"
                        src={source}
                        basename={basename}
                        loadingFallback={<CenteredSpinner />}
                        data={{ ...data, id: params.id }}
                    />
                )}
            </Fragment>
        );
    }),
);
